// Generated by CoffeeScript 1.11.1
(function() {
  var Descriptor, OriginPathInfo;

  Descriptor = require('../descriptor');

  module.exports = OriginPathInfo = (function() {
    OriginPathInfo.prototype.id = 3000;

    OriginPathInfo.prototype.name = 'originPathInfo';

    function OriginPathInfo(resource) {
      this.resource = resource;
      this.file = this.resource.file;
    }

    OriginPathInfo.prototype.parse = function() {
      this.file.seek(4, true);
      return this.data = new Descriptor(this.file).parse();
    };

    return OriginPathInfo;

  })();

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./lib/psd/resources/origin_path_info.js
// module id = 97
// module chunks = 0